import { useEffect, useState } from "react";
import { getRelevantChallengePlans } from "../../api";

const useChallengePlans = (courseNo = "") => {
  const [relevantPlans, setRelevantPlans] = useState<Record<string, any>>([]);
  useEffect(() => {
    getRelevantChallengePlans().then((plans) => {
      setRelevantPlans(plans.filter((p) => p.course_no !== courseNo));
    });
  }, [courseNo]);
  return relevantPlans;
};

export default useChallengePlans;
